import { createAction } from 'redux-actions';
import { toPairs } from 'lodash';
import GridFiltersType from '../types/GridFiltersType';

export const setColumnVisibility = createAction(GridFiltersType.actions.setColumnVisibility, (list, column, visibility = true) => ({ list, column, visibility }));
export const setGridColumns = createAction(GridFiltersType.actions.setGridColumns, (list, allColumns) => ({ list, allColumns }));

export const setGridFilters = createAction(GridFiltersType.actions.setGridFilters, (list, filtersObj) => {
  const filters = toPairs(filtersObj)
    .map(([filter, value]) => ({ filter, value }))
    .filter((filter) => filter.value !== '');
  return { list, filters };
});

export const fetchGridFiltersSuccess = createAction(GridFiltersType.actions.fetchGridFiltersSuccess, (list, responseData, fromBackButton) => ({ list, responseData, fromBackButton }));
